import type { components } from '../../api/generated/schema';
import type { Block, NewReport, ReportReceipt } from '../../domain/safety';
import { toPersonRef } from '../mapping';

type S = components['schemas'];

export function toBlock(b: S['Block']): Block {
  return { id: b.id, person: b.person ? toPersonRef(b.person) : null, createdAt: b.created_at };
}

export function toNewReport(r: NewReport): S['ReportCreateRequest'] {
  return { target_kind: r.targetKind, target_id: r.targetId, note: r.note };
}

export function toReportReceipt(r: S['ReportReceipt']): ReportReceipt {
  return { id: r.id, createdAt: r.created_at };
}
